module.exports = __webpack_public_path__ + "da3211130cfc02a30fef6501cc864c35.png";